import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatDate, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLOSE_REQUEST,
	STR_CONFIRM_PROCESSING,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_COULD_NOT_FETCH_DATA,
	STR_COULD_NOT_PROCESS_REQUEST,
	STR_CURRENT_PARTICIPANTS_COUNT,
	STR_FLOAT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PLEASE_PROVIDE_SECRET_CODE,
	STR_RECENT_REQUESTS,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_REQUEST_SECRET_CODE,
	STR_REQUEST_WAS_CLOSED,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SEND_MESSAGE_TO_AGENT,
	STR_SERVICE_PROVIDER,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_AGENT_PROFILE,
	STR_YOUR_REQUEST
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdClose, MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPeople, MdSupportAgent, MdTranslate, MdVerified } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp, FaUserTag } from "react-icons/fa6";
import { IoMdCloseCircle } from "react-icons/io";

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [agentRequestData, setAgentRequestData] = useState(null);
	const [agentData, setAgentData] = useState(null);
	const [participants, setParticipants] = useState([]);
	const [requestCode, setRequestCode] = useState('');

	async function init() {
		//run initializations here
		setReady(false);
		//..
		await Promise.all([
			getAgentRequestData(),
		])
		setReady(true);
	}

	async function getAgentData(agentId) {
		await callApi('get-agent-data', { id: agentId }).then((response) => {
			if(response.status === 1) {
				setAgentData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	} 

	async function getAgentRequestData() {
		await callApi('get-agent-request-data', { id }).then(async (response) => {
			if(response.status === 1) {
				setAgentRequestData(response.data);
				await getAgentData(response.data.userId)
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	} 

	async function closeRequest() {
		setLoading(true);
		await callApi('close-agent-request', { id }).then(async (response) => {
			if(response.status === 1) {
				appContext.getAllAgentRequests();
				await getAgentRequestData();
			} else {
				appContext.tellError(STR_COULD_NOT_PROCESS_REQUEST[appContext.language]);
			}
		})
		setLoading(false)
	} 

	async function confirmProcessing() {
		if(requestCode && requestCode.trim().length > 0) {
			setLoading(true);
			await callApi('confirm-agent-request-processing', { requestId: id, requestCode, processedBy: appContext.currentUserData.id }).then(async (response) => {
				if(response.status === 1) {
					appContext.getAllAgentRequests();
					await getAgentRequestData();
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_PLEASE_PROVIDE_SECRET_CODE[appContext.language]);
		}
	}

	async function contactAgent() {
		//first mark this as a perticipant
		setLoading(true);
		await callApi(
			'record-agent-request-participant',
			{
				requestId: id,
				participantId: appContext.currentUserData.id,
			}
		).then((response) => {
			if(response.status === 1) {
				appContext.navTo({
					item: 'view',
					subItem: 'inbox',
					extraItem: agentData.id,
				});
			} else {
				appContext.tellError(response.msg);
			}
		})
		setLoading(false);
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		if(agentRequestData) {
			setParticipants(JSON.parse(agentRequestData.participants));
		}
	}, [ agentRequestData ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])


	if (ready && agentRequestData && agentData) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingBottom: "calc(var(--topBarHeight) + 40px)",
					}}
					className="mNoScrollBar"
				>
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<div className="card">
									<div className="card-body">
										<div className="row">

											<div className="col-12">
												<div className="d-flex mb-4 mt-4">
													{
														(agentRequestData.requestType === 'float') ?
														<>
															<FaMoneyBillTrendUp className="align-self-center text-primary" size={16}/>
															<span
																style={{
																	fontSize: "14px",
																	marginLeft: "5px"
																}}
																className="align-self-center font-bold text-primary"
															>
																{STR_FLOAT[appContext.language]}
															</span>
														</>
														
														:""
													}
									
													{
														(agentRequestData.requestType === 'cash') ?
														<>
															<FaMoneyBillTransfer className="align-self-center text-secondary" size={16}/>
															<span
																style={{
																	fontSize: "14px",
																	marginLeft: "5px"
																}}
																className="align-self-center font-bold text-secondary"
															>
																{STR_CASH[appContext.language]}
															</span>
														</>
														
														:""
													}
												</div>
											</div>

											<div className="col-12">
												<h6
													style={{
														fontSize: "36px",
														marginBottom: "30px"
													}}
												>
													<span>{formatMoney(agentRequestData.amount)}</span>
													<span className="font-semi-bold" style={{ fontSize: "18px" }}> TZS</span>
												</h6>

												<h6
													style={{
														fontSize: "18px"
													}}
												>
													{appContext.getTillTypeName(agentRequestData.tillType)}
												</h6>
									
												{
													(Number(appContext.currentUserData.id) === Number(agentRequestData.userId)) ?
													<span className="badge bg-secondary">{STR_YOUR_REQUEST[appContext.language]}</span>
													:""
												}

												<div className="text-end">
													<h6
														className="font-regular"
														style={{
															fontSize: "12px"
														}}
													>
														{formatDate(agentRequestData.dateCreated)}
													</h6>
												</div>

												<hr/>

												<div className="text-center text-primary">
													<h6
														style={{
															padding: "20px"
														}}
													>
														<FaUserTag
															size={56}
															className="text-muted"
														/>
														<br/>
														<span
															className="font-bold"
															style={{
																fontSize: "20px"
															}}
														>
															{agentData.agentName}
															{(agentData.agentVerificationStatus === 'verified') ? <MdVerified className="text-primary"/> :""}
															
														</span>
													</h6>
												</div>
											</div>

											
					
										</div>
									</div>
								</div>
							</div>

							{
								(agentRequestData.status === 'open') ?
								<div className="col-md-12">
									<div className="mt-5 mb-5">
										<h6
											style={{
												fontSize: "24px"
											}}
										>
											<MdPeople size={24}/> &nbsp;
											{(participants && participants.length > 0) ? participants.length : 0}
										</h6>

										<h6
											style={{
												fontSize: "12px",
											}}
											className="font-semi-bold"
										>
											{STR_CURRENT_PARTICIPANTS_COUNT[appContext.language]}
										</h6>
									</div>
									
									{
										(Number(appContext.currentUserData.id) === Number(agentData.id) && agentRequestData.status === 'open') ?
										<div className="mt-5 mb-5">
											<h6
												style={{
													fontSize: "24px"
												}}
											>
												{agentRequestData.requestCode}
											</h6>

											<h6
												style={{
													fontSize: "12px",
												}}
												className="font-semi-bold"
											>
												{STR_REQUEST_SECRET_CODE[appContext.language]}
											</h6>
										</div>
										:""
									}


									{
										(Number(appContext.currentUserData.id) !== Number(agentData.id)) ?
										<>
											<button
												className="btn btn-block btn-primary btn-padded btn-rounded mt-3"
												onClick={() => {
													appContext.navTo({
														item: 'view',
														subItem: 'agent_profile',
														extraItem: agentData.id,
													})
												}}
											>
												{STR_VIEW_AGENT_PROFILE[appContext.language]}
											</button>

											<button
												className="btn btn-block btn-outline-primary btn-padded btn-rounded mt-3"
												onClick={() => {
													contactAgent();
												}}
											>
												{STR_SEND_MESSAGE_TO_AGENT[appContext.language]}
											</button>

											{
												(participants.includes(Number(appContext.currentUserData.id))) ?
												<div className="card mt-4">
													<div className="card-body">
														<div className="mt-2 mb-4">
															<label className="form-label" style={{ fontSize: "12px" }}>{STR_REQUEST_SECRET_CODE[appContext.language]}</label>
															<input
																className="form-control"
																type="password"
																value={requestCode}
																onChange={(e) => setRequestCode(e.target.value)}
															/>
														</div>

														<button
															className="btn btn-block btn-danger btn-padded btn-rounded"
															onClick={confirmProcessing}
														>
															{STR_CONFIRM_PROCESSING[appContext.language]}
														</button>
													</div>
												</div>
												:""
											}
										</>
										:""
									}

									{
										(Number(appContext.currentUserData.id) === Number(agentData.id) && agentRequestData.status === 'open') ?
										<button
											className="btn btn-block btn-outline-primary btn-padded btn-rounded mt-3"
											onClick={() => {
												appContext.activateDialog({
													message: STR_CLOSE_REQUEST[appContext.language],
													onConfirm: closeRequest,
												})
											}}
										>
											{STR_CLOSE_REQUEST[appContext.language]}
										</button>
										:""
									}
								</div>
								:
								(agentRequestData.status === 'closed') ?
								<div className="col-md-12">
									<div className="text-center mt-2 mb-2">
										{
											(agentRequestData.isProcessed === 'yes') ?
											<h6
												style={{
													fontSize: "16px",
												}}
												className="font-semi-bold"
											>
												<MdCheckCircle className="text-success" size={32}/>
											</h6>
											:
											<h6
												style={{
													fontSize: "16px",
												}}
												className="font-semi-bold"
											>
												<IoMdCloseCircle size={32}/>
											</h6>
										}
										<h6
											style={{
												fontSize: "16px",
											}}
											className="font-semi-bold"
										>
											{STR_REQUEST_WAS_CLOSED[appContext.language]}
										</h6>
									</div>
								</div>
								:""
							}
						</div>
					</div>
	
	
				</div>
			)
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}